import { useWizard } from '@/context/wizard';
import type {
  OfferCheckoutResponse,
  OfferWithDetails,
} from '@/data/catalog/offer/interfaces';
import type { RegistrationFormData } from '@/packages/courses/components/user-data-form/schema';
import type {
  CreditCardFormData,
  InstallmentsFormData,
  PaymentMethodFormData,
} from '@/packages/courses/pages/checkout/schema';
import { CheckoutStepIds } from '@/packages/courses/pages/checkout/types';

export interface CheckoutFlowValues {
  offer?: OfferWithDetails;
  subscriptionId?: number;
  orderId?: number;
  coupon?: { code?: string; discount?: number };
  [CheckoutStepIds.CustomerInfo]?: RegistrationFormData;
  [CheckoutStepIds.PaymentMethod]?: PaymentMethodFormData;
  [CheckoutStepIds.CreditCardDetails]?: CreditCardFormData;
  [CheckoutStepIds.CreditCardInstallments]?: InstallmentsFormData;
  [CheckoutStepIds.DataConfirmation]?: { confirmed: boolean };
  [CheckoutStepIds.PixBankSlip]?: {
    pixBoletoGenerated: boolean;
    paymentData?: OfferCheckoutResponse['data']['paymentData'];
  };
  [CheckoutStepIds.PaymentStatus]?: undefined;
}

export const useCheckoutWizard = () => {
  const wizard = useWizard();
  const values = wizard.values as CheckoutFlowValues;
  const paymentMethod = values?.[CheckoutStepIds.PaymentMethod]?.paymentMethod;
  const customerInfo = values?.[CheckoutStepIds.CustomerInfo];
  const creditCardData = values?.[CheckoutStepIds.CreditCardDetails];
  const installmentsData = values?.[CheckoutStepIds.CreditCardInstallments];

  return {
    ...wizard,
    values,
    orderId: values?.orderId,
    currentStepId: wizard.currentStepId as CheckoutStepIds,
    offer: values.offer,
    subscriptionId: values.subscriptionId,
    paymentMethod,
    customerInfo,
    creditCardData,
    installmentsData,
    coupon: values.coupon,
  };
};
